import { render, staticRenderFns } from "./Orders_Main.vue?vue&type=template&id=6d99a4f0&scoped=true&"
import script from "./Orders_Main.vue?vue&type=script&lang=js&"
export * from "./Orders_Main.vue?vue&type=script&lang=js&"
import style0 from "./Orders_Main.vue?vue&type=style&index=0&id=6d99a4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d99a4f0",
  null
  
)

export default component.exports